import { StorageModule } from "../modules/storage";
import { deepCopy, duplicateRemoval } from '../util';
import { message } from "antd";
import * as apis from '../api/networkDisk'
import moment from "moment";

interface Action {
    type: string;
    data: any;
    path?: string;
}

interface State {
    token: string;
    userInfo: any;
    subjectInfo: any;
    subjectInfoPart: any;
    showNode: boolean;
    showLable: boolean;
    onLine: any;
    memosNum: any;
    bottombarMsg: boolean;
    noticeMsg: any;
    chatMsg: any;
    newChat: any;
    //navbar控制甘特图搜索
    //甘特图日期
    ganttDate: boolean;
    //甘特图执行人
    ganttUser: boolean;
    //记录画布信息
    graphInfo: any;
    userRemove: boolean;
    showChat: boolean | string;
    showChatType: string;
    showCreateChat: boolean;
    chatId: string;
    chatDiscussionId: string;
    rerenderCount: number;
    executorUserShow: boolean;
    calendarExecutorRows: any,
    calendarExecutorRowKeys: any,
    calendarLable: any,
    ganttExecutorRows: any,
    ganttExecutoRowKeys: any,
    //定位便签位置
    pingMemo: any,
    ImgNotesTag: any,
    ImgNotesTagIndex: any,
    //监听图片注释 是否添加注释状态
    watchIsMark: any,
    //标签类型
    tagMeta: any,
    replacementMeta: any,
    task_attachment: any,
    //选中的单个memo
    memoInfo: any,
    //当前用户编辑的便签
    myEditMemo: any,
    //层级试图新建时的父级便签id
    relationbelongtos_superid: any,
    //选中的tagMeta
    selectTagMeta: any,
    //显示的meta
    showTagMeta: any,
    showDrawLabel: any,
    calendarExecutor: any,
    subjectCurType: any,
    calendarCurTimeType: any,
    taskCalendarCurTimeType: any,
    calendarCurTime: any,
    //主题层级数
    viewHierarchyInfo: any,
    //是否屏
    modelFullScreen: false,
    //主题新建便签 鼠标位置
    mousePosition: null
}
let subjectInfo: any = localStorage.getItem('subjectInfo')
let graphInfo: any = localStorage.getItem('things_x6_container')
console.log(typeof StorageModule.get('things_showlable'))
//已记录的执行人中如果有选中的执行人，则标记，否则则删除已选择执行人
let isExecutor = false
let _calendarExecutor = JSON.parse((localStorage as any)?.getItem('things_calendarExecutor'))
if ((localStorage as any)?.getItem('things_calendarExecutorRowKeys') && JSON.parse((localStorage as any)?.getItem('things_calendarExecutorRowKeys')).some((i: any) => i == _calendarExecutor?.id)) {
    isExecutor = true
}
const tictactoeState = {
    token: StorageModule.getUser().token,
    userInfo: StorageModule.getUser().user,
    subjectInfoPart: {},
    subjectInfo: JSON.parse(subjectInfo) || {
        subjectId: "",
        subjectTitle: "",
        subjectCatalogue: [],
        total: 0,
        initData: {
            memos: [],
            relationBelongTos: [],
            comments: [],
            owner: {},
            userInfos: [],
            users: []
        },
        data: {
            memos: [],
            relationBelongTos: [],
            comments: [],
            owner: {},
            userInfos: [],
            users: []
        },
        memosNum: 0,
        bottombarMsg: false,
        noticeMsg: "",
    },
    rerenderCount: 0,
    //讨论组在线用户
    onLine: [],
    showNode: false,
    showLable: (StorageModule.get('things_showlable') === 'true') ? true : false,
    ganttDate: false,
    ganttUser: false,
    graphInfo: {
        x: Number(JSON.parse(graphInfo)?.x) || 0,
        y: Number(JSON.parse(graphInfo)?.y) || 0
    },
    userRemove: false,
    showChat: false,
    showChatType: "",
    showCreateChat: false,
    chatId: '',
    chatDiscussionId: '',
    executorUserShow: false,
    calendarExecutorRows: JSON.parse((localStorage as any)?.getItem('things_calendarExecutorRows')) || [],
    calendarExecutorRowKeys: JSON.parse((localStorage as any)?.getItem('things_calendarExecutorRowKeys')) || [],
    ganttExecutorRows: [],
    ganttExecutoRowKeys: [],
    calendarLable: {},
    pingMemo: {},
    ImgNotesTag: [],
    ImgNotesTagIndex: null,
    watchIsMark: true,
    tagMeta: JSON.parse((localStorage as any)?.getItem('things_tagMeta')) || [],
    replacementMeta: JSON.parse((localStorage as any)?.getItem('things_replacementMeta')) || [],
    task_attachment: JSON.parse((localStorage as any)?.getItem('things_task_attachment')) || [],
    //便签信息，便签业务数据都放在memoInfo.data里
    memoInfo: {},
    // memoInfo: JSON.parse((localStorage as any)?.getItem('things_memoInfo')) || {},
    myEditMemo: {},
    relationbelongtos_superid: null,
    selectTagMeta: {},
    showTagMeta: JSON.parse((localStorage as any)?.getItem('things_showTagMeta')) || ['attachment', 'replacement', 'classifier'],
    showDrawLabel: false,
    calendarExecutor: (isExecutor) ? _calendarExecutor : null || null,
    subjectCurType: (localStorage as any)?.getItem('things_subjectCurType') || 'default',
    calendarCurTimeType: (localStorage as any)?.getItem('things_calendarCurTimeType') || 'year',
    calendarCurTime: (localStorage as any)?.getItem('things_calendarCurTime') || moment(new Date()).format("YYYY-MM-DD"),
    taskCalendarCurTimeType: (localStorage as any)?.getItem('things_taskCalendarCurTimeType') || 'day',
    viewHierarchyInfo: {
        hierarchyMax: 0,
        chooseLevel: 0
    },
    modelFullScreen: JSON.parse((localStorage as any)?.getItem('modelFullScreen'))
}

const setTictactoe = (state: State, action: Action) => {
    switch (action.type) {
        // 设置token
        case 'SET_TOKEN': {
            state.token = action.data
            return { ...state }
        }
        // 设置token
        case 'SET_USERINFO': {
            state.userInfo = action.data
            return { ...state }
        }
        case 'SET_RERENDERCOUNT': {
            state.rerenderCount = action.data
            return { ...state }
        }
        case 'SET_MODELFULLSCREEN': {
            state.modelFullScreen = action.data
            StorageModule.set('modelFullScreen', action.data)

            return { ...state }
        }
        case 'SET_CHATID': {
            state.chatId = action.data
            return { ...state }
        }
        case 'SET_CHATDISCUSSIONID': {
            state.chatDiscussionId = action.data
            return { ...state }
        }
        case 'SET_SHOWCREATECHAT': {
            state.showCreateChat = action.data
            return { ...state }
        }
        case 'SET_SHOWCHAT': {
            console.log('SET_SHOWCHAT', action.data)
            setTictactoe(state, { type: 'SET_CLOSESHOWALL', data: action.data ? ['showChat'] : null })

            // state.showChat = action.data
            return { ...state }
        }
        //谈论类型
        case 'SET_SHOWCHATTYPE': {
            state.showChatType = action.data
            return { ...state }
        }
        case 'SET_MOUSEPOSITION': {
            state.mousePosition = action.data
            return { ...state }
        }

        // 设置主题信息
        case 'SET_SUBJECTINFO': {
            console.log('SET_SUBJECTINFO', action.data)
            state.subjectInfo = action.data
            console.log(action.data)
            let _data: any = deepCopy(action.data.data) || null
            console.log(_data)
            if (_data) {
                delete _data.memos
                delete _data.relationBelongTos
            }
            let _params = {
                catalogueId: action.data.catalogueId,
                subjectCatalogue: action.data.subjectCatalogue,
                subjectId: action.data.subjectId,
                subjectTitle: action.data.subjectTitle,
                total: action.data.total,
                data: _data
            }
            StorageModule.set('subjectInfo', { ..._params })
            return { ...state }
        }
        // 设置主题信息
        case 'SET_SUBJECTINFO_PART': {
            console.log('触发了', state.subjectInfo, action.data)
            let data: any = deepCopy(state.subjectInfo.data)
            let res: any
            const { comments, memos, relationBelongTos, id, userInfos, users } = action.data || null;
            if (comments && comments.length > 0) {
                res = dealData('comments', data, action.data)
            }
            if (memos && memos.length > 0) {
                res = dealData('memos', data, action.data)
            }
            if (relationBelongTos && relationBelongTos.length > 0) {
                res = dealData('relationBelongTos', data, action.data)
            }
            if (userInfos && userInfos.length > 0) {
                data.userInfos = userInfos
                data.users = users
            }
            state.subjectInfo = { ...state.subjectInfo, total: state.subjectInfo.data?.memos?.length, data: { ...res || deepCopy(state.subjectInfo.data), userInfos: userInfos, users: users } }
            StorageModule.set('subjectInfo', state.subjectInfo)
            state.subjectInfoPart = { ...action.data, permissions: state.subjectInfo.permissions }
            return { ...state }
        }
        // 设置显示隐藏
        case 'SET_SHOWNODE': {
            state.showNode = action.data
            // StorageModule.set('showNode', state.showNode)
            return { ...state }
        }
        //谈论组移除当前用户
        case 'SET_USER_REMOVE': {
            state.userRemove = action.data
            return { ...state }
        }

        // 记录画布信息
        // case 'SET_GRAPHINFO': {
        //     state.graphInfo = action.data
        //     // StorageModule.set('showNode', state.showNode)
        //     return { ...state }
        // }
        // 设置显示标签
        case 'SET_SHOWLABLE': {
            setTictactoe(state, { type: 'SET_CLOSESHOWALL', data: action.data ? ['showLable'] : null })

            // state.showLable = action.data
            // StorageModule.set('things_showlable', action.data)
            return { ...state }
        }
        //展示执行人筛选列表
        case 'SET_EXECUTORUSERSHOW': {
            state.executorUserShow = action.data
            return { ...state }
        }
        //日历视图执行人集合所选择的执行人
        case 'SET_CALENDAREXECUTOR': {
            state.calendarExecutor = action.data;
            StorageModule.set('things_calendarExecutor', state.calendarExecutor)
            return { ...state }
        }
        //共享日历视图筛选执行人item集合
        case 'SET_CALENDAREXECUTORROWS': {
            state.calendarExecutorRows = duplicateRemoval(action.data, "id");
            StorageModule.set('things_calendarExecutorRows', state.calendarExecutorRows)
            return { ...state }
        }//共享日历视图筛选执行人id集合
        case 'SET_CALENDAREXECUTOROWKEYS': {
            state.calendarExecutorRowKeys = Array.from(new Set(action.data))
            console.log('state.calendarExecutorRowKeys.some((i: any) => state.calendarExecutor', state.calendarExecutorRowKeys.some((i: any) => state.calendarExecutor))
            if (!state.calendarExecutorRowKeys.some((i: any) => state.calendarExecutor)) {
                setTictactoe(state, { type: 'SET_CALENDAREXECUTOR', data: null })
            }
            StorageModule.set('things_calendarExecutorRowKeys', state.calendarExecutorRowKeys)
            console.log(state.calendarExecutorRowKeys)
            return { ...state }
        }
        //甘特图执行人
        case 'SET_GANTTEXECUTORROWS': {
            state.ganttExecutorRows = duplicateRemoval(action.data, "id");
            return { ...state }
        }
        //甘特图执行人
        case 'SET_GANTTEXECUTOROWKEYS': {
            state.ganttExecutoRowKeys = Array.from(new Set(action.data))
            return { ...state }
        }
        // 监听主题在线用户
        case 'SET_ON_LINE': {
            state.onLine = action.data
            return { ...state }
        }
        // 监听选中便签数量
        case 'SET_MEMOS_NUM': {
            state.memosNum = action.data
            return { ...state }
        }
        //监听底部消息状态
        case 'SET_BOTTOMBAR_MSG': {
            console.log('SET_BOTTOMBAR_MSG', action.data)
            state.bottombarMsg = action.data
            return { ...state }
        }
        //监听讨论组消息
        case 'SET_NOTICE_MSG': {
            console.log(action.data)
            state.noticeMsg = action.data
            getNoticeId(action.data)
            return { ...state }
        }
        //监听便签讨论
        case 'SET_NEW_CHAT': {
            console.log(action.data)
            state.newChat = action.data
            return { ...state }
        }
        case 'SET_CHAT_MSG': {
            console.log('SET_CHAT_MSG', action.data)
            state.chatMsg = action.data
            return { ...state }
        }
        //监听甘特图筛选，日期筛选
        case 'SET_GANTTDATE': {
            state.ganttDate = action.data
            return { ...state }
        }
        //监听甘特图筛选，执行人筛选
        case 'SET_GANTTUSER': {
            state.ganttUser = action.data
            return { ...state }
        }
        //监听日历视图标签变动
        case 'SET_CALENDARLABLE': {
            console.log('SET_CALENDARLABLE', action.data)
            state.calendarLable = action.data
            return { ...state }
        }
        //记录日历点击任务的便签信息
        case 'SET_PING_MEMO': {
            console.log('SET_PING_MEMO', action.data)
            state.pingMemo = action.data
            return { ...state }
        }
        //图片标注
        case 'SET_IMGNOTESTAG': {
            console.log('SET_IMGNOTESTAG', action.data)
            state.ImgNotesTag = action.data
            return { ...state }
        }//图片标注
        case 'SET_IMGNOTESTAG_INDEX': {
            console.log('SET_IMGNOTESTAG_INDEX', action.data)
            state.ImgNotesTagIndex = action.data
            return { ...state }
        }
        case 'SET_WATCHISMARK': {
            state.watchIsMark = action.data
            return { ...state }
        }
        case 'SET_TAGMETA': {
            state.tagMeta = action.data
            let _tagMeta = [{
                id: 'text',
                mimeType: 'text',
                name: "文本",
                notation: "MarkdownTag",
                type: "replacement"
            }]
            let _tagMeta2: any = deepCopy(state.tagMeta.filter((i: any) => i.type == 'replacement'))
            _tagMeta = _tagMeta.concat(_tagMeta2)
            StorageModule.set('things_tagMeta', state.tagMeta)
            state.replacementMeta = _tagMeta
            StorageModule.set('things_replacementMeta', _tagMeta)
            let _tagMeta3: any = deepCopy(state.tagMeta.filter((i: any) => i.type == 'attachment'))
            state.task_attachment = _tagMeta3

            StorageModule.set('things_task_attachment', _tagMeta3)

            return { ...state }
        }
        case 'GET_TAGMETA': {
            getTagMeta(state)
            return { ...state }
        }
        case 'SET_MEMOINFO': {
            console.log('SET_MEMOINFO', action.data)
            state.memoInfo = action.data
            // StorageModule.set('things_memoInfo', state.memoInfo)
            return { ...state }
        }
        case 'SET_MYEDITMEMO': {
            //它和SET_MEMOINFO数据格式完全一样，兼容用户改变便签格式但是不保存的场景
            console.log('SET_MYEDITMEMO', action.data)
            state.myEditMemo = action.data
            // StorageModule.set('things_memoInfo', state.memoInfo)
            return { ...state }
        }
        case 'SET_RELATIONBELONGTOS_SUPERID': {
            //层级试图记录父级便签的id
            state.relationbelongtos_superid = action.data
            return { ...state }
        }

        case 'SET_SELECTTAGMETA': {
            state.selectTagMeta = action.data
            return { ...state }
        }
        case 'SET_SHOWTAGMETA': {
            state.showTagMeta = action.data
            StorageModule.set('things_showTagMeta', state.showTagMeta)
            return { ...state }
        }
        case 'SET_SHOWDRAWLABEL': {
            console.log('SET_SHOWDRAWLABEL', action.data)
            setTictactoe(state, { type: 'SET_CLOSESHOWALL', data: action.data ? ['showDrawLabel'] : null })
            // state.showDrawLabel = action.data
            // StorageModule.set('things_showTagMeta', state.showTagMeta)
            return { ...state }
        }
        //监听日历视图查询范围
        case 'SET_SUBJECTCURTYPE': {
            state.subjectCurType = action.data
            // setTictactoe(state, { type: 'SET_CALENDAREXECUTOR', data: null })
            // setTictactoe(state, { type: 'SET_CALENDAREXECUTORROWS', data: [] })
            // setTictactoe(state, { type: 'SET_CALENDAREXECUTOROWKEYS', data: [] })
            StorageModule.set('things_subjectCurType', action.data)
            return { ...state }
        }
        //监听navbar日历视图查询年季月周日值
        case 'SET_CALENDARCURTIMETYPE': {
            state.calendarCurTimeType = action.data
            StorageModule.set('things_calendarCurTimeType', action.data)
            return { ...state }
        }
        //监听日历看板查询年季月周日值
        case 'SET_TASKCALENDARCURTIMETYPE': {
            state.taskCalendarCurTimeType = action.data
            StorageModule.set('things_taskCalendarCurTimeType', action.data)
            return { ...state }
        }

        //监听navbar日历视图选择的日期
        case 'SET_CALENDARCURTIME': {
            state.calendarCurTime = action.data
            StorageModule.set('things_calendarCurTime', action.data)
            return { ...state }
        }
        case 'SET_CLOSESHOWALL'
            : {
                //action.data是数组，如果有不想关闭的，将key放进数组即可
                console.log('SET_CLOSESHOWALL', action.data)
                state.showDrawLabel = false
                state.showChat = false
                state.showCreateChat = false
                state.showLable = false
                action.data && action.data.map((i: any) => {
                    state[i] = true
                })
                // StorageModule.set('things_showTagMeta', state.showTagMeta)
                return { ...state }
            }
        case 'SET_VIEW_HIERARCHY_INFO': {
            state.viewHierarchyInfo = action.data
            return { ...state }
        }
        default: {
            return state
        }
    }
}
async function getNoticeId(id: any) {
    try {
        let res: any = await apis.noticeId(id)
        if (res.ok && JSON.parse(res.data.content[0].value).type === 'topic_user_data_change') {
            console.log(res)

            message.info(`你受邀参加“${JSON.parse(res.data.content[0].value).topicName}”的讨论！`);

        }
    } catch { }
}
//更新Meta
async function getTagMeta(state: State) {
    try {
        let res: any = await apis.tagMeta()
        if (res.ok) {
            setTictactoe(state, { type: 'SET_TAGMETA', data: res.data })
            setTictactoe(state, { type: 'SET_SHOWNODE', data: false })
        }
        return res.data
    } catch {

    }

}
function dealData(type: any, data: any, newData?: any) {
    // let new_memos: any = []
    let new_memos: any = [];

    if (!data || !newData) return data

    if (type == 'relationBelongTos') {
        console.log(type, newData[type][0].id)
    }
    newData[type].map((i: any) => {
        console.log('元素', i.id, data[type])
        let flag = false
        data[type]?.map((j: any, num: any) => {
            if (j.id === i.id) {
                data[type][num] = i
                flag = true
            }
        })
        if (i.$operate$ === 'save') {

            if (!flag) {
                console.log('增加', i.id)
                new_memos.push(i)
            }
        } else if (i.$operate$ === "delete") {
            data[type] = data[type]?.filter((j: any, num: any) => j.id !== i.id)
            data.relationBelongTos = data.relationBelongTos.filter((item: any) => item.suborId !== i.id && item.superId !== i.id)
        }
    })
    data[type] = data[type]?.concat(new_memos)
    console.log('data[type]', data[type])

    return data
}
export {
    tictactoeState,
    setTictactoe
}
